import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

/**
 * One row of the member's own "blocked members" list.
 *
 * **Ids and a timestamp, nothing else** — the same discipline the conversation
 * list keeps (P18a): who the member is composed by `GET /members?ids=` through
 * the visibility resolver (N18), never by a second shape assembled here that
 * would have to re-implement the blur rule and the matched-only carve-out.
 *
 * The blocker is the token, so the row never names them. `blockedAt` is the
 * fact the surface shows and is separate from `createdAt` for the reason
 * `likes.decidedAt` is: no backfill may move it.
 *
 * A row whose member does not come back from the batch is drawn as unavailable
 * rather than as an error — a blocked member who has since been suspended or
 * closed their account is still on the list, and unblocking them is still a
 * thing the member may do.
 */
export const BlockSchema = z
  .object({
    blockedUserId: UuidSchema,
    blockedAt: z.iso.datetime(),
  })
  .strict();

export type Block = z.infer<typeof BlockSchema>;
